var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluentAdd48Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4003 10.5184C10.6443 10.2744 11.0403 10.2744 11.2842 10.5184L16.8527 16.0868L22.4212 10.5184C22.5384 10.4011 22.6973 10.3353 22.8631 10.3353C23.0289 10.3353 23.1878 10.4011 23.305 10.5184C23.4223 10.6356 23.4881 10.7945 23.4881 10.9603C23.4881 11.1261 23.4223 11.285 23.305 11.4022L17.7366 16.9707L23.305 22.5392C23.4223 22.6564 23.4881 22.8154 23.4881 22.9811C23.4881 23.1469 23.4223 23.3058 23.305 23.4231C23.1878 23.5403 23.0289 23.6061 22.8631 23.6061C22.6973 23.6061 22.5384 23.5403 22.4212 23.4231L16.8527 17.8546L11.2842 23.4231C11.167 23.5403 11.008 23.6061 10.8423 23.6061C10.6765 23.6061 10.5176 23.5403 10.4003 23.4231C10.2831 23.3058 10.2173 23.1469 10.2173 22.9811C10.2173 22.8153 10.2831 22.6564 10.4003 22.5392L15.9688 16.9707L10.4003 11.4022C10.1564 11.1583 10.1564 10.7623 10.4003 10.5184Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentAdd48Regular);
export default __webpack_public_path__ + "static/media/fluent_add-48-regular.695bb006cfce64632c8f957c7010abef.svg";
export { ForwardRef as ReactComponent };